import { render, staticRenderFns } from "./warehousIndex.vue?vue&type=template&id=ec86ae48&scoped=true&"
import script from "./warehousIndex.vue?vue&type=script&lang=js&"
export * from "./warehousIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec86ae48",
  null
  
)

export default component.exports